export enum TemplatePlanTypeEnum {
  DAY = 'DAY',
  WEEKLY = 'WEEKLY',
  CUSTOM = 'CUSTOM'
}
